// test.foobar

require('../module.foobar');



//////////////////
// WEBPACK FOOTER
// ./~/jest-cli/src/__tests__/test_root/__testtests__/test.foobar
// module id = 3127
// module chunks = 0